import { forEach } from 'lodash';
import BasePage from '../../components/base-page/base-page';

import type { UiElement } from '../../../shared/ui-element/ui-element';

import jump from '../../utils/jump';

import './mac-apps-report.scss';

export const ERROR_COLOR = '#ff2c47';
export const VALID_COLOR = '#26262b';

class MacAppsReport extends BasePage {
  ui = {
    form: '.js-report-form',
    reportSection: '.js-report-section',
    iframe: '.js-report-response-iframe',
    ctaButton: '.js-cta-btn',
    submitButton: '.js-submit-btn',
    returnToFormButton: '.js-go-back-btn',
    successMessageBlock: '.js-success-message-block',
    errorMessage: '.js-error-message',
    checkBox: '.js-report-checkbox',
    checkBoxLabel: '.js-report-checkbox-label',
  };

  uiCollections = {
    formInputs: '.js-input',
  };

  events = {
    'submit @ui.form': 'handleFormSubmit',
    'change @uiCollections.formInputs': 'handleTrimValueOnChange',
    'click @ui.ctaButton': 'handleGetReportClick',
    'click @ui.returnToFormButton': 'handleReturnToFormClick',
    'click @ui.submitButton': 'handleFormValidationClick',
  };

  onInit() {
    super.onInit();
  }

  handleGetReportClick = () => {
    this.jumpToForm();
  };

  handleTrimValueOnChange = () => {
    const inputs = (this.uiCollections.formInputs as unknown as HTMLFormControlsCollection);

    forEach(inputs, (inputElement) => {
      const input = (inputElement as unknown as HTMLInputElement);
      const trimmedValue = input.value.trim();

      input.value = trimmedValue;
    });
  };

  handleReturnToFormClick = () => {
    const form = (this.ui.form as unknown as HTMLFormElement);
    const successMessageBlock = (this.ui.successMessageBlock as unknown as HTMLElement);

    form.style.display = 'block';
    successMessageBlock.style.display = 'none';
    form.reset();
  };

  handleFormValidationClick = () => {
    const checkBox = (this.ui.checkBox as unknown as HTMLFormElement);
    const checkBoxLabel = (this.ui.checkBoxLabel as unknown as HTMLFormElement);
    const form = (this.ui.form as unknown as HTMLFormElement);
    const formInputs = (this.uiCollections.formInputs as unknown as HTMLFormControlsCollection);
    const errorMessage = (this.ui.errorMessage as unknown as HTMLElement);

    if (!checkBox.checked) {
      checkBoxLabel.style.borderColor = ERROR_COLOR;
    } else {
      checkBoxLabel.style.borderColor = VALID_COLOR;
    }

    if (!form.reportValidity()) {
      errorMessage.style.visibility = 'visible';
    } else {
      errorMessage.style.visibility = 'hidden';
    }

    forEach(formInputs, (inputElement) => {
      const input = (inputElement as unknown as HTMLFormElement);

      if (input.checkValidity()) {
        input.classList.remove('report-form__input-error');
        input.classList.add('form-control_light');
      } else {
        input.classList.remove('form-control_light');
        input.classList.add('report-form__input-error');
      }
    });
  };

  jumpToForm() {
    jump(this.ui.reportSection, {
      offset: -75, // sticky navigation height margin + report form title
    });
  }

  handleFormSubmit = () => {
    const form = (this.ui.form as unknown as HTMLFormElement);
    const successMessageBlock = (this.ui.successMessageBlock as unknown as HTMLElement);

    successMessageBlock.style.display = 'flex';
    form.style.display = 'none';
  };
}

export default MacAppsReport;

(MacAppsReport as UiElement).initOnDomLoaded();
